import { AppTheme } from "./app-theme";
import { environment } from "../../../environments/environment";

/** Runtime logo URL (updated when admin theme loads from API). */
let brandingLogoSrc: string = AppTheme.logoSrc;

/** API host without /api suffix — from environment (local, QA, prod). */
export function getApiOrigin(): string {
  return environment.apiBaseUrl.replace(/\/api\/?$/i, "");
}

export function getBrandingLogoSrc(): string {
  return brandingLogoSrc;
}

export function setBrandingLogoSrc(url: string): void {
  brandingLogoSrc = resolveBrandingLogoUrl(url);
}

/**
 * Store uploaded API logos as site-relative paths; keep external CDN URLs as-is.
 */
export function normalizeLogoUrlForStorage(url?: string | null): string | null {
  if (!url?.trim()) {
    return null;
  }

  const value = url.trim();

  if (value.startsWith("assets/") || value.startsWith("data:")) {
    return value;
  }

  if (value.startsWith("/branding/")) {
    return value;
  }

  if (/^https?:\/\//i.test(value)) {
    try {
      const parsed = new URL(value);
      if (/\/branding\//i.test(parsed.pathname)) {
        return `${parsed.pathname}${parsed.search}`;
      }
    } catch {
      return value;
    }
    return value;
  }

  if (value.startsWith("branding/")) {
    return `/${value}`;
  }

  return value;
}

/**
 * Resolve logo for display: API /branding/... uses current environment API origin.
 */
export function resolveBrandingLogoUrl(url?: string | null): string {
  const fallback = AppTheme.logoSrc;
  if (!url?.trim()) {
    return fallback;
  }

  let value = url.trim();

  if (/^https?:\/\//i.test(value)) {
    try {
      const parsed = new URL(value);
      if (/\/branding\//i.test(parsed.pathname)) {
        value = `${parsed.pathname}${parsed.search}`;
      } else {
        return value;
      }
    } catch {
      return fallback;
    }
  }

  if (value.startsWith("data:")) {
    return value;
  }

  if (value.startsWith("assets/")) {
    return value;
  }

  if (value.startsWith("/")) {
    return `${getApiOrigin()}${value}`;
  }

  return value;
}
